/**
 * Cart enquiry reminder lines — £0 / qty 1 reminders only.
 * Never enter OrderDesk, Firestore order_items, stock reservation, or confirmation item tables.
 */

import { getProductImageUrls } from '../services/productGalleryService';

export const CART_ENQUIRY_LINE_KIND = 'enquiry';

export function isCartEnquiryLine(item) {
    if (!item || typeof item !== 'object') return false;
    if (item.enquiryOnly === true) return true;
    if (item.lineKind === CART_ENQUIRY_LINE_KIND) return true;
    return false;
}

/** Split cart into orderable lines vs enquiry reminders (order preserved within each group). */
export function partitionCartItems(cartItems = []) {
    const orderable = [];
    const enquiries = [];
    for (const item of cartItems || []) {
        if (isCartEnquiryLine(item)) enquiries.push(item);
        else orderable.push(item);
    }
    return { orderable, enquiries };
}

export function filterOrderableCartItems(cartItems = []) {
    return (cartItems || []).filter((item) => !isCartEnquiryLine(item));
}

export function mergeOrderableWithEnquiryLines(orderableLines = [], enquiryLines = []) {
    return [...(orderableLines || []), ...(enquiryLines || [])];
}

/**
 * Build a zeroed enquiry reminder line for the cart (display only).
 * @param {object} product — browse product shape (name, code, imageUrl, packSize, pricingKey, …)
 * @param {string} [note]
 */
export function buildEnquiryCartReminderLine(product, note = '') {
    const code = String(product?.code || product?.Code || '').trim();
    const name = String(product?.name || product?.Name || code || 'Product').trim();
    return {
        name,
        code,
        price: 0,
        quantity: 1,
        stock: 0,
        packSize: product?.packSize || product?.['Pack Size'] || '',
        imageUrl:
            getProductImageUrls(product)[0]
            || product?.imageUrl
            || product?.['Image URL']
            || '/placeholder-product.svg',
        minOrder: 0,
        pricingKey: product?.pricingKey
            ? String(product.pricingKey).trim().toLowerCase()
            : undefined,
        enquiryOnly: true,
        lineKind: CART_ENQUIRY_LINE_KIND,
        enquiryNote: String(note || '').trim(),
        priceListSynced: true,
    };
}
